if (!customElements.get('taffstyle-privacy')) {
  customElements.define('taffstyle-privacy', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.ts-privacy-panel');
      this.error = this.querySelector('.ts-privacy-error');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-privacy-settings')) this.showPreferences();
        if (button.hasAttribute('data-privacy-close')) this.close();
        if (button.dataset.privacyChoice) this.save(button.dataset.privacyChoice === 'allow');
        if (button.hasAttribute('data-privacy-save')) this.save();
      }, options);
      document.addEventListener('click', event => {
        if (event.target.closest('[data-footer-privacy-open]')) this.open(true);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.dataset.decided === 'true') this.close();
      }, options);
      document.addEventListener('visitorConsentCollected', () => this.refresh(), options);
      window.addEventListener('resize', () => this.position(), options);
      window.visualViewport?.addEventListener('resize', () => this.position(), options);
      this.position();
      this.loadApi();
    }
    loadApi(attempt = 0) {
      if (window.Shopify?.customerPrivacy?.currentVisitorConsent) {
        this.api = window.Shopify.customerPrivacy;
        this.dataset.ready = 'true';
        this.refresh();
        if (this.dataset.decided !== 'true') this.open(false);
        return;
      }
      if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
          if (error || !window.Shopify.customerPrivacy) this.failed();
          else this.loadApi();
        });
      } else if (attempt < 30) {
        this.retry = setTimeout(() => this.loadApi(attempt + 1), 250);
      } else this.failed();
    }
    refresh() {
      if (!this.api) return;
      const consent = this.api.currentVisitorConsent();
      const keys = ['analytics','marketing','preferences'];
      this.dataset.decided = String(keys.every(key => consent[key] === 'yes' || consent[key] === 'no'));
      this.dataset.consent = keys.map(key => key + ':' + (consent[key] || 'unset')).join(',');
      this.querySelectorAll('[data-consent-category]').forEach(input => {
        input.checked = consent[input.dataset.consentCategory] === 'yes';
      });
      this.querySelector('[data-privacy-close]').hidden = this.dataset.decided !== 'true';
      this.announce();
    }
    open(focus) {
      this.returnFocus = focus ? document.activeElement : null;
      this.refresh();
      this.panel.hidden = false;
      this.dataset.open = 'true';
      this.position();
      this.announce();
      if (focus) this.querySelector('[data-privacy-choice]').focus();
    }
    close() {
      this.panel.hidden = true;
      this.dataset.open = 'false';
      this.querySelector('.ts-privacy-preferences').hidden = true;
      this.querySelector('[data-privacy-save]').hidden = true;
      this.querySelector('[data-privacy-settings]').setAttribute('aria-expanded','false');
      this.announce();
      if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
      this.returnFocus = null;
    }
    showPreferences() {
      const preferences = this.querySelector('.ts-privacy-preferences');
      preferences.hidden = !preferences.hidden;
      this.querySelector('[data-privacy-save]').hidden = preferences.hidden;
      this.querySelector('[data-privacy-settings]').setAttribute('aria-expanded', String(!preferences.hidden));
      if (!preferences.hidden) preferences.querySelector('input').focus({preventScroll:false});
    }
    save(all) {
      if (this.saving) return;
      if (!this.api) { this.failed(); this.loadApi(); return; }
      const consent = {};
      this.querySelectorAll('[data-consent-category]').forEach(input => {
        consent[input.dataset.consentCategory] = typeof all === 'boolean' ? all : input.checked;
      });
      this.saving = true;
      this.error.hidden = true;
      this.panel.querySelectorAll('button').forEach(button => button.disabled = true);
      const fail = () => {
        this.saving = false;
        this.panel.querySelectorAll('button').forEach(button => button.disabled = false);
        this.failed();
      };
      this.saveTimeout = setTimeout(fail,10000);
      try {
        this.api.setTrackingConsent(consent, () => {
          clearTimeout(this.saveTimeout);
          this.saving = false;
          this.panel.querySelectorAll('button').forEach(button => button.disabled = false);
          const saved = this.api.currentVisitorConsent();
          if (!Object.entries(consent).every(([key,value]) => saved[key] === (value ? 'yes' : 'no'))) { fail(); return; }
          this.refresh();
          this.close();
          this.querySelector('.ts-privacy-status').textContent = this.dataset.saved;
        });
      } catch { clearTimeout(this.saveTimeout); fail(); }
    }
    failed() {
      this.panel.hidden = false;
      this.dataset.open = 'true';
      this.error.textContent = this.dataset.error;
      this.error.hidden = false;
      this.announce();
    }
    position() {
      const bar = document.getElementById('PBarNextFrameWrapper');
      let bottom = 16;
      if (bar) {
        const rect = bar.getBoundingClientRect();
        if (rect.height && rect.top > window.innerHeight / 2 && rect.top < window.innerHeight) bottom = window.innerHeight - rect.top + 12;
        if (!this.barObserver) { this.barObserver = new ResizeObserver(() => this.position()); this.barObserver.observe(bar); }
      }
      document.documentElement.style.setProperty('--ts-floating-bottom',bottom+'px');
    }
    announce() { document.dispatchEvent(new CustomEvent('taffstyle:privacy-state')); }
    disconnectedCallback() { this.events?.abort(); this.barObserver?.disconnect(); clearTimeout(this.retry); clearTimeout(this.saveTimeout); }
  });
}
